import { FormControl } from '@angular/forms';
import { CcdLocaliteModel } from '@cnaf.usagers.appli/cnaf-commons-dral';

export class LogementModel {
    
    public localite: CcdLocaliteModel;
    public lieuResidence: string;
    public typeOccupation: string;
    public typeCrous: string | undefined;
    public estMeuble: string;
    public mttDeclare: number;
    public estConventionne: string;

    constructor(
        localite: CcdLocaliteModel,
        lieuResidence: string, // = cdTypeLogement
        typeOccupation: string,
        typeCrous: string,
        estMeuble: string,
        mttDeclare: number,
        estConventionne: string
    ) { 
        this.localite = localite;
        this.lieuResidence = lieuResidence;
        this.typeOccupation = typeOccupation;
        this.typeCrous = typeCrous;
        this.estMeuble = estMeuble;
        this.mttDeclare = mttDeclare;
        this.estConventionne = estConventionne;
    }
}

export class InfoLongementForm {
    cpCommune?:FormControl<string>;
    lieuResidence?:FormControl<string>;
    typeOccupation?:FormControl<string>;
    typeCrous?:FormControl<string>;
    estMeuble?:FormControl<string>;
    estConventionne?:FormControl<string>;
    mttDeclare?:FormControl<string>;
}
